import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  pageTransition,
  pageVariants,
} from "../../../../global/Animations/Animations";
import { Box, Text, useColorMode } from "@chakra-ui/react";
import ReadingCard from "./ReadingCard";
import heartRateImage from "../../../../../assets/ReadingsImage/heartRate.png";
import bloodPressureImage from "../../../../../assets/ReadingsImage/bloodPressure.png";
import bloodSugarImage from "../../../../../assets/ReadingsImage/bloodSugar.png";
import heightImage from "../../../../../assets/ReadingsImage/height.png";
import temperatureImage from "../../../../../assets/ReadingsImage/temperature.png";
import weightImage from "../../../../../assets/ReadingsImage/weight.png";
import { checkColorMode } from "../../../../global/changeColor";
const Readings = ({ history, readings, requestes }) => {
  const [bloodPressure, setBloodPressure] = useState();
  const [height, setHeight] = useState();
  const [weight, setWeight] = useState();
  const [heartRate, setHeartRate] = useState();
  const [bloodSugar, setBloodSugar] = useState();
  const [temperature, setTemperature] = useState();
  const { colorMode } = useColorMode();
  useEffect(() => {
    if (readings && readings.length > 0) {
      setBloodPressure(
        readings.find((reading) => {
          return reading.type === "blood-pressure";
        })
      );
      setHeight(
        readings.find((reading) => {
          return reading.type === "height";
        })
      );
      setWeight(
        readings.find((reading) => {
          return reading.type === "weight";
        })
      );
      setHeartRate(
        readings.find((reading) => {
          return reading.type === "heart-rate";
        })
      );
      setBloodSugar(
        readings.find((reading) => {
          return reading.type === "blood-sugar";
        })
      );
      setTemperature(
        readings.find((reading) => {
          return reading.type === "temperature";
        })
      );
    }
  }, [readings]);
  return (
    <motion.div
      className=""
      initial="out"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Box className="row my-3">
        <Text
          fontSize="2xl"
          fontWeight="semibold"
          color={checkColorMode(colorMode)}
        >
          Readings
        </Text>
        <ReadingCard
          item={bloodPressure}
          image={bloodPressureImage}
          name="Blood Pressure"
          feildName="blood-pressure"
          requestes={requestes}
        />
        <ReadingCard
          item={height}
          image={heightImage}
          name="Height"
          feildName="height"
          requestes={requestes}
        />
        <ReadingCard
          item={weight}
          image={weightImage}
          name="Weight"
          feildName="weight"
          requestes={requestes}
        />
        <ReadingCard
          item={heartRate}
          image={heartRateImage}
          name="Heart Rate"
          feildName="heart-rate"
          requestes={requestes}
        />
        <ReadingCard
          item={bloodSugar}
          image={bloodSugarImage}
          name="Blood Sugar"
          feildName="blood-sugar"
          requestes={requestes}
        />
        <ReadingCard
          item={temperature}
          image={temperatureImage}
          name="Temperature"
          feildName="temperature"
          requestes={requestes}
        />
      </Box>
    </motion.div>
  );
};

export default Readings;
